/**
 * 客户端push板块
 */
"use strict";
angular.module("clientPushManagementModule", [])
    .controller("clientPushManagementCtrl", ['$scope', '$q', '$modal', 'trsHttpService', '$filter', 'planCommandMonitorService', 'modalDialog', function ($scope, $q, $modal, trsHttpService, $filter, planCommandMonitorService, modalDialog) {
        initStatus();
        initData();

        /**
         * [initStatu 初始化状态]
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.status = {
                copyCurrPage: 1
            };

            $scope.data = {
                clientPushList: [],
            };

            $scope.page = {
                CURRPAGE: 1,
                PAGECOUNT: 0,
                PAGESIZE: 20,
                ITEMCOUNT: 0,
            };

            $scope.params = {
                "serviceid": "appPushMgr",
                "typeid": "screen",
                "modelid": "search",
                "page_no": $scope.page.CURRPAGE - 1,
                "page_size": $scope.page.PAGESIZE,
            };
        }

        /**
         * [initData 初始化数据]
         * @return {[type]} [description]
         */
        function initData() {
            requestData();
        }

        /**
         * [requestData 请求数据]
         * @return {[type]} [description]
         */
        function requestData() {
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), $scope.params, 'post').then(function (data) {
                $scope.data.clientPushList = [].concat(data.MAPRESULT.content.CONTENT);
                $scope.page.ITEMCOUNT = data.MAPRESULT.content.TOTALELEMENTS;
                $scope.page.PAGECOUNT = data.MAPRESULT.content.TOTALPAGES;
            });
        }

        /**
         * [timeFormat 时间格式化]
         * @param  {[type]} data [description]
         * @return {[type]}      [description]
         */
        $scope.timeFormat = function (data) {
            return $filter('date')(data, 'yyyy-MM-dd HH:mm:ss').toString();
        }

        /**
         * [view 新开页面查看]
         * @param  {[type]} url [description]
         * @return {[type]}     [description]
         */
        $scope.view = function (temp) {
            var url = temp.URL + '&siteids=' + temp.ID + ';&title=' + temp.TITLE;
            window.open(url);
        }
        $scope.addClient = function () {
            var defer = $q.defer();
            var modalInstance = $modal.open({
                templateUrl: "./planningResource/commandMonitor/clientPushManagement/addAndEdit/addAndEdit_tpl.html",
                windowClass: 'clientPushManagement-addClient-window',
                backdrop: false,
                controller: "clientPushManagementAddAndEditCtrl",
                resolve: {
                    selectedItem: function() {
                        return '';
                    }
                }
            });
            //关闭弹窗
            modalInstance.result.then(function (result) {
                requestData();
                defer.resolve(result);
            }, function () {
                defer.reject("cancle");
            });
            return defer.promise;
        }

        $scope.editClient = function (temp) {
            var defer = $q.defer();
            var modalInstance = $modal.open({
                templateUrl: "./planningResource/commandMonitor/clientPushManagement/addAndEdit/addAndEdit_tpl.html",
                windowClass: 'clientPushManagement-addClient-window',
                backdrop: false,
                controller: "clientPushManagementAddAndEditCtrl",
                resolve: {
                    selectedItem: function() {
                        return temp;
                    }
                }
            });
            //关闭弹窗
            modalInstance.result.then(function (result) {
                requestData();
                defer.resolve(result);
            }, function () {
                defer.reject("cancle");
            });
            return defer.promise;
        }
        /**
         * [share 分享链接]
         * @param  {[type]} id [description]
         * @return {[type]}    [description]
         */
        $scope.share = function (id) {
            planCommandMonitorService.share(id, '11', "复制链接和密码");
        };

        /**
         * [deleteClient 删除单个客户端push]
         * @return {[type]} [description]
         */
        $scope.deleteClient = function (id) {
            var params = {
                "serviceid": "appPushMgr",
                "modelid": "delete",
                "typeid": "screen",
                "id": id,
            }
            modalDialog.confirmModal("删除提示", "是否确认删除？", function () {
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function (data) {
                    requestData();
                });
            }, function () {
                return;
            })
        };

        /**
         * [selectPageNum 更改单页显示的数据条数]
         * @return {[type]} [description]
         */
        $scope.selectPageNum = function () {
            $scope.params.page_size = $scope.page.PAGESIZE;
            $scope.params.page_no = $scope.status.copyCurrPage - 1;
            requestData();
        };

        /**
         * [changePage 更改分页请求数据]
         * @return {[type]} [description]
         */
        $scope.changePage = function () {
            $scope.params.page_no = $scope.page.CURRPAGE - 1;
            requestData();
        }
    }]);